import React from 'react';
import { Flex } from 'components/common/styled/common-styled';
import { ResourceParagraph } from 'components/theme/Typography/ResourceTypography';
import styled from 'styled-components';
import { TruncatedText, TruncationMode } from 'components/TruncatedText';
import { PublicListingDetailsV3 } from 'types/listingV3';
import { formatListingMedia } from 'utils/listings';
import { useIsMobile } from 'WindowDimensionProvider';
import { CollectionPageNonMappedHeaderSkeleton } from '../pages/Skeleton';

interface Props {
  listing: PublicListingDetailsV3;
  isLoading?: boolean;
}

export const CollectionHero: React.FC<Props> = ({ listing, isLoading }) => {
  const isMobile = useIsMobile();
  if (isLoading) {
    return <CollectionPageNonMappedHeaderSkeleton />;
  }
  const coverMedia = formatListingMedia(listing.medias).find(
    (media) => media.kind === 'cover',
  );
  return (
    <Flex direction="column" gap={24} alignItem="flex-start">
      <HeroImageWrapper>
        <Renderer
          src={isMobile ? coverMedia?.urlMobile : coverMedia?.urlDesktop}
          alt={listing.title ?? undefined}
        />
      </HeroImageWrapper>
      <Flex direction="column" gap={12} alignItem="flex-start">
        <CollectionDetails>
          <ResourceParagraph
            className="collection-details"
            mobileFontSize="12px"
          >
            <CollectionTitle className="collection-title">
              {listing.title}
            </CollectionTitle>
            <TruncatedText
              text={listing.summary}
              isRichText
              maxLines={2}
              mode={TruncationMode.INLINE}
            />
          </ResourceParagraph>
        </CollectionDetails>
      </Flex>
    </Flex>
  );
};

const HeroImageWrapper = styled.div`
  margin-bottom: 0;
  border-radius: 0;
  display: flex;
  position: relative;
  width: 100%;
  overflow: hidden;
  max-height: 367px;
  align-items: center;
  justify-content: center;

  > picture {
    width: 100%;
  }
`;

const Renderer = styled.img`
  object-fit: cover;
  border-radius: 0;
  object-position: center;
  width: 100%;
`;

const CollectionDetails = styled.div`
  > p > p {
    ~ div {
      margin-top: -24px;
    }
  }
`;

export const CollectionTitle = styled.span<{
  allowMultipleLines?: boolean;
}>`
  font-size: 28px;
  line-height: 40px;
  font-weight: 700;
  white-space: ${({ allowMultipleLines }) =>
    allowMultipleLines ? 'normal' : 'nowrap'};
  text-overflow: ellipsis;
  overflow: hidden;
`;
